import { api } from './api';

type FeedbackSubmission = {
  product: string;
  productLabel: string;
  category: string;
  description: string;
};

const feedbackApi = api.injectEndpoints({
  endpoints: (builder) => ({
    submitFeedback: builder.mutation<{ ok: boolean }, FeedbackSubmission>({
      query: (body) => ({
        url: 'feedback',
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const { useSubmitFeedbackMutation } = feedbackApi;

export { feedbackApi };
